import HomeMan from "./HomeMan";

export default HomeMan;